// usage examples:
//
// import {getScrollTop} from './lib/utilities';
// or
// import * as Utils from './lib/utilities';

/**
 * Detect breakpoints - see https://adactio.com/journal/5429 for more info on usage
 * @return {String} - the value of breakpoint set in the CSS
 */
export function getBreakpoint() {
  return window
    .getComputedStyle(document.body, ':after')
    .getPropertyValue('content');
}

/**
 * Get scroll position
 * @return {Undefined}
 */
export function getScrollTop() {
  const doc = document.documentElement;
  return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
}

/**
 * Initialize Class from selector
 * @param {String} selector css selector to get bojects
 * @param {Class} Class Class to initialize
 * @param {Object} args (optionnal) args to send to constructor
 * @param {DOM} ctx (optionnal) root DOM element to look for items
 *
 * @return  {Array} Initialized objects
 */
export function creator(selector, Class, args, ctx) {
  if (!selector || !Class) {
    return;
  }

  let itemsEl = null;
  const items = [];


  if (ctx) {
    itemsEl = ctx.querySelectorAll(selector);
  } else {
    itemsEl = document.querySelectorAll(selector);
  }

  for (let i = 0; i < itemsEl.length; i++) {
    if (args) {
      items.push(new Class(itemsEl[i], args));
    } else {
      items.push(new Class(itemsEl[i]));
    }
  }

  return items;
}

/**
 *
 * @param {instance} context
 */
export function updateBodyClass(context) {
  const page = context.cache.getCurrentPage();

  // remove old classes
  document.body.className.split(' ').forEach((className) => {
    if (className !== '') {
      document.body.classList.remove(className);
    }
  });

  // add new classes
  if (page.pageClass !== '') {
    page.pageClass.split(' ').forEach((className) => {
      if (className !== '') {
        document.body.classList.add(className);
      }
    });
  }
}

/**
 * reloadScripts
 */
export const reloadScripts = () => {
  const arrayify = (list) => Array.prototype.slice.call(list);
  const runScript = (originalElement) => {
    const element = document.createElement('script');

    for (const {name, value} of arrayify(originalElement.attributes)) {
      element.setAttribute(name, value);
    }
    element.textContent = originalElement.textContent;
    element.setAttribute('async', 'false');

    originalElement.replaceWith(element);
    return element;
  };

  const scripts = arrayify(document.head.querySelectorAll('script[data-swup-reload-script]'));
  scripts.forEach((script) => runScript(script));
  // console.log(`Executed ${scripts.length} scripts.`);
};
